import { IsMobile } from "./CheckPlatform";

/** Web・モバイルによって、使用するライブラリを切り替えます */
export const ModalLibrary = IsMobile()
  ? require("react-native").Modal
  : require("modal-react-native-web");
